export default __webpack_public_path__ + "static/media/1.70dcd1a7.png";